import React, { ChangeEvent, CSSProperties, useRef, useState } from 'react'
import { ExternalProfileType } from '../../containers/SignInPage/types'

// Styles
import './styles.scss'

// Icons
import IconEmptyAvatar from './images/iconEmptyAvatar'
import IconEdit from './images/iconEdit'
// import IconSave from './images/iconSave'
import IconCancel from './images/iconCancel'

export default ({
  style,
  onUpload,
  onRemove,
  profile,
}: {
  style: CSSProperties
  onUpload: (photo: File) => void
  onRemove: () => void
  profile: ExternalProfileType
}) => {
  const [isEdit, setIsEdit] = useState<boolean>(false)

  const refFile = useRef<HTMLInputElement | null>(null)

  const handleImagePicker = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const photo = event.target.files[0]
      onUpload(photo)
      setIsEdit(false)
    }
  }

  return (
    <div style={style} className={'avatar-edit-block'}>
      {profile.avatar_url ? (
        <div className={'avatar'}>
          <img src={profile.avatar_url} />
        </div>
      ) : (
        <IconEmptyAvatar />
      )}
      <div className={'avatar-edit-block__center'}>
        {isEdit ? (
          <div className={'buttons'}>
            <input
              id={'file'}
              type="file"
              ref={refFile}
              onChange={handleImagePicker}
            />
            <button onClick={() => refFile.current?.click()}>
              Загрузить фото
            </button>
            <button
              onClick={() => {
                onRemove()
                setIsEdit(false)
              }}
            >
              Удалить фото
            </button>
          </div>
        ) : (
          <div className={'title'}>
            Фото
            <br />
            профиля
          </div>
        )}
      </div>
      <div className={'avatar-edit-block__nav'}>
        {isEdit ? (
          <>
            {/* <IconSave*/}
            {/*  onClick={() => setIsEdit(false)}*/}
            {/*  style={{ marginRight: 9 }}*/}
            {/* />*/}
            <IconCancel onClick={() => setIsEdit(false)} />
          </>
        ) : (
          <IconEdit onClick={() => setIsEdit(true)} />
        )}
      </div>
    </div>
  )
}
